import { Trans } from "react-i18next";

export default function Footer() {
	return (
		<footer className="py-10">
			<p className="container text-muted-foreground text-sm">
				<Trans i18nKey="footer.copyright.text" />
			</p>
		</footer>
	);
}
